import {
  Avatar,
  Box,
  Card,
  CardContent,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import {
  Maybe,
  PendingPurchaseItemDetailFragment,
} from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, CellFrame, Organism } from '@/core/architecture'

type PurchaseInfoProps = {
  loading: boolean
  artist?: Maybe<PendingPurchaseItemDetailFragment['artist']> | null
}

export const PurchaseInfo: Organism<PurchaseInfoProps> = ({
  loading,
  artist,
}) => {
  const { t } = useTranslation('storePurchaseOrderDetail')
  if (loading) {
    return <PurchaseInfoSkeleton />
  }
  return (
    <CellFrame sx={{ pb: 5 }}>
      <Typography variant="h5" color="text.secondary" sx={{ py: 3 }}>
        {t('storeInfo')}
      </Typography>
      <Card elevation={0} sx={{ borderRadius: 2 }}>
        <CardContent sx={{ px: 5, py: 3, '&:last-child': { pb: 3 } }}>
          <Stack direction="row" spacing={3} alignItems="center">
            <Avatar
              src={artist?.avatar?.smallUri ?? ''}
              sx={{ width: 40, height: 40 }}
            />
            <Stack spacing={1}>
              <Typography variant="subtitle1">{artist?.displayName}</Typography>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </CellFrame>
  )
}

const PurchaseInfoSkeleton: Cell = () => (
  <CellFrame sx={{ pb: 5 }}>
    <Box sx={{ py: 2 }}>
      <SkeletonText variant="h3" width="50%" />
    </Box>
    <Card elevation={0} sx={{ borderRadius: 2 }}>
      <CardContent sx={{ px: 5, py: 3, '&:last-child': { pb: 3 } }}>
        <Stack direction="row" spacing={3} alignItems="center">
          <Skeleton variant="circular" sx={{ width: 40, height: 40 }} />
          <Stack flex={1}>
            <SkeletonText variant="small" width="75%" />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  </CellFrame>
)
